export default {
  perfectMoney: {
    title: "للمتابعة، انقر على الخيار المطلوب:",
    buyButton: "شراء",
    sellButton: "بيع",
    notVerified: {
      title: "أنت غير مؤكد",
      subtitle: "لشراء وبيع Perfect Money، أكمل التحقق الخاص بك",
      verificationButton: "أكمل التحقق"
    },
    buyPage: {
      title: 'أنت "تشتري" {n}.',
      availableBalance: "الرصيد القابل للسحب:",
      payment: "أنت تدفع",
      noResults: "لم يتم العثور على نتائج.",
      noData: "لم يتم العثور على بيانات.",
      received: "ستستلم (تقريبًا)",
      pmLabel: "عنوان Perfect Money",
      rules: {
        part1: "بوضع هذا الطلب، أؤكد أنني قرأت وقبلت",
        linkTitle: "قواعد Excoino",
        part2: "."
      },
      submitButton: "تابع عملية {n}",
      balanceNotEnough: "رصيد محفظتك غير كاف.",
      maxReceive: "الحد الأقصى للمبلغ المستلم هو {amount}.",
      minReceive: "الحد الأدنى للمبلغ المستلم هو {amount}."
    },
    sellPage: {
      title: 'أنت "تبيع" {n}.',
      payment: "أنت تدفع",
      noResults: "لم يتم العثور على نتائج.",
      noData: "لم يتم العثور على بيانات.",
      received: "ستستلم (تقريبًا)",
      rules: {
        part1: "بوضع هذا الطلب، أؤكد أنني قرأت وقبلت",
        linkTitle: "قواعد Excoino",
        part2: "."
      },
      submitButton: "تابع عملية {n}",
      evCode: "رمز القسيمة",
      evNumber: "رقم القسيمة"
    },
    orderProcess: {
      cancelButton: "إلغاء الطلب",
      buy: {
        expireTitle: "انتهت صلاحية إكمال هذا الطلب.",
        payment: "الدفع",
        netReceived: "المبلغ المستلم الصافي",
        fee: "الرسوم:",
        addressTitle: "العنوان",
        submitButton: "تابع عملية الشراء",
        receivedCodeLabel: "رمز SMS",
        resendCodeTitle: "إعادة إرسال الرمز في {n} ثانية",
        resendCodeButton: "إعادة إرسال رمز التحقق",
        verifyOtpButton: "تأكيد وإنهاء",
        successOrder: {
          title: "تم تسجيل طلب الشراء الخاص بك بنجاح",
          subtitle: "بعد تأكيد Excoino، سيتم إكمال طلبك.",
          payment: "الدفع",
          netReceived: "المبلغ المستلم الصافي",
          transactionNumber: "رقم المعاملة:",
          fee: "الرسوم:",
          addressTitle: "العنوان",
          submitDate: "تاريخ ووقت التسجيل:",
          transactionHistoryHistoryButton: "عرض حالة المعاملة",
          dashboardButton: "اذهب إلى لوحة التحكم"
        }
      },
      sell: {
        expireTitle: "انتهت صلاحية إكمال هذا الطلب.",
        payment: "الدفع",
        netReceived: "المبلغ المستلم الصافي",
        fee: "الرسوم:",
        submitButton: "تابع عملية البيع",
        perfectMoneyHint:
          "للاتصال ببوابة دفع Perfect Money، استخدم عنوان IP غير الإيراني.",
        successOrder: {
          title: "تم تسجيل طلب الشراء الخاص بك بنجاح",
          payment: "الدفع",
          netReceived: "المبلغ المستلم الصافي",
          transactionNumber: "رقم المعاملة:",
          fee: "الرسوم:",
          changeFee: "رسوم التحويل:",
          submitDate: "تاريخ ووقت التسجيل:",
          transactionHistoryHistoryButton: "عرض حالة المعاملة",
          dashboardButton: "اذهب إلى لوحة التحكم"
        }
      }
    },
    reSubmitSell: {
      title: "معاملة غير ناجحة",
      payment: "الدفع",
      netReceived: "المبلغ المستلم الصافي",
      transactionNumber: "رقم المعاملة:",
      paymentPrice: "مبلغ الدفع:",
      submitDate: "تاريخ ووقت التسجيل:",
      transactionHistoryHistoryButton: "عرض حالة المعاملة",
      dashboardButton: "اذهب إلى لوحة التحكم",
      repeatOrderButton: "إعادة الطلب"
    }
  }
};
